import React from 'react';
import {
  Box,
  SimpleGrid,
  VStack,
  HStack,
  Text,
  Badge,
  Button,
  Icon,
  useColorModeValue,
  Divider,
} from '@chakra-ui/react';
import { GitBranch, ArrowRight, Database, Shield, FileText } from 'lucide-react';

const WorkflowPanel: React.FC = () => {
  const bgColor = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.700');

  const workflows = [
    {
      title: 'Data Science Review',
      description: 'Send selected ideas to Data Science team for feasibility analysis',
      icon: Database,
      color: 'blue',
      steps: ['Impact Assessment', 'Resource Estimation', 'Technical Feasibility'],
    },
    {
      title: 'Governance Review',
      description: 'Route ideas through compliance and governance checks',
      icon: Shield,
      color: 'purple',
      steps: ['Policy Compliance', 'Risk Assessment', 'Security Review'],
    },
    {
      title: 'Content Creation',
      description: 'Transform approved ideas into SentientIQ content',
      icon: FileText,
      color: 'green',
      steps: ['Content Draft', 'Clinical Review', 'Publication'],
    },
  ];

  return (
    <VStack spacing={6} align="stretch">
      <SimpleGrid columns={3} spacing={6}>
        {workflows.map((workflow) => (
          <Box
            key={workflow.title}
            bg={bgColor}
            p={6}
            borderRadius="lg"
            boxShadow="sm"
            border="1px"
            borderColor={borderColor}
          >
            <VStack align="start" spacing={4}>
              <HStack>
                <Icon as={workflow.icon} boxSize={5} color={`${workflow.color}.500`} />
                <Text fontSize="lg" fontWeight="medium">
                  {workflow.title}
                </Text>
              </HStack>
              <Text fontSize="sm" color="gray.500">
                {workflow.description}
              </Text>
              <Divider />
              <VStack align="start" spacing={2} width="100%">
                {workflow.steps.map((step, index) => (
                  <HStack key={step} width="100%" justify="space-between">
                    <Text fontSize="sm">{step}</Text>
                    <Icon as={ArrowRight} boxSize={4} color="gray.400" />
                  </HStack>
                ))}
              </VStack>
              <Button
                leftIcon={<GitBranch size={16} />}
                size="sm"
                colorScheme={workflow.color}
                variant="outline"
                width="100%"
              >
                Start Workflow
              </Button>
            </VStack>
          </Box>
        ))}
      </SimpleGrid>
    </VStack>
  );
};

export default WorkflowPanel;
